<div class="all-in-one-table content-layout">
    <calsoft-page-header [height]="'180px'" background="url(assets/images/headers/pattern-3.png)" [reverse]="true">
    </calsoft-page-header>
    <div class="container" [formGroup]="firstFormGroup">
        <calsoft-breadcrumbs [url]="id==0?'googleCalender,Add Meeting':'googleCalender,Edit meeting'"
            [currentPage]="id==0?'Meeting,Add meeting':'Meeting,Edit Meeting'" [header]="'primary'">
        </calsoft-breadcrumbs>
        <div fxLayout="column" fxLayoutGap="24px">
            <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" fxLayoutGap="24px">
                <div class="card border space" fxFlex="100%" fxFlex.gt-sm>
                    <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
                        <div class="name" fxLayoutGap="10px" fxLayoutAlign="start center">
                            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-1' + '__' + sanitizedUrl" matTooltip="Back" (click)="cancel()" mat-icon-button>
                                <mat-icon>keyboard_arrow_left</mat-icon>
                            </button>
                            {{title}}
                        </div>
                        <div fxLayoutGap="10px" fxLayout="row" class="btn" fxLayoutAlign="end center" fxHide.xs
                            fxHide.sm fxShow.md fxShow.lg fxShow.xl>
                            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-2' + '__' + sanitizedUrl" mat-icon-button *ngIf="id != 0" (click)="audit('tab')">
                                <mat-icon>calendar_today</mat-icon>
                            </button>



                            <div *ngIf="id != 0">

                                <button [attr.guide]="'add-edit-google-calendar-service-account-btn-3' + '__' + sanitizedUrl" *ngIf="(firstFormGroup.value.meetLink != null && firstFormGroup.value.meetLink != undefined && firstFormGroup.value.meetLink != '') && (firstFormGroup.value.meetingDriveLink == '' || firstFormGroup.value.meetingDriveLink == null || firstFormGroup.value.meetingDriveLink ==undefined)"
                                    mat-raised-button (click)="generationLink()">Generate
                                    Drive Link</button>
                            </div>

                            <div >
                                <calsoft-outlook-calender (setIsAuthenticated)="setAuth($event)"></calsoft-outlook-calender>
                            </div>

                            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-4' + '__' + sanitizedUrl" [disabled]="text !='Save'" (click)="createCalenderEvent()" mat-raised-button>
                                {{text}}
                                <mat-icon *ngIf="text !='Save' ">
                                    <mat-spinner color="primary" diameter="20">
                                    </mat-spinner>
                                </mat-icon>
                            </button>
                        </div>

                        <div fxLayoutGap="10px" fxLayout="row" class="btn" fxLayoutAlign="end center" fxShow.xs
                            fxShow.sm fxHide.md fxHide.lg fxHide.xl>
                            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-5' + '__' + sanitizedUrl" mat-icon-button *ngIf="id != 0" (click)="audit('tab')">
                                <mat-icon>calendar_today</mat-icon>
                            </button>
                        </div>
                    </div>
                    <div fxLayoutGap="10px" fxLayout="row" class="btn" fxLayoutAlign="center center" fxShow.xs fxShow.sm
                        fxHide.md fxHide.lg fxHide.xl style="margin-top: 10px;">
                        <div *ngIf="id != 0">

                            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-6' + '__' + sanitizedUrl" *ngIf="(firstFormGroup.value.meetLink != null && firstFormGroup.value.meetLink != undefined && firstFormGroup.value.meetLink != '') && (firstFormGroup.value.meetingDriveLink == '' || firstFormGroup.value.meetingDriveLink == null || firstFormGroup.value.meetingDriveLink ==undefined)"
                                mat-raised-button (click)="generationLink()">Generate
                                Drive Link</button>
                        </div>

                     


                        <button [attr.guide]="'add-edit-google-calendar-service-account-btn-7' + '__' + sanitizedUrl" [disabled]="text !='Save'" (click)="createCalenderEvent()" mat-raised-button>
                            {{text}}
                            <mat-icon *ngIf="text !='Save' ">
                                <mat-spinner color="primary" diameter="20">
                                </mat-spinner>
                            </mat-icon>
                        </button>
                    </div>
                    <div class="content" fxLayout="column">
                        <div class="result" fxLayout="column">
                            <div class="container">
                                <div id="content">
                                    <div class="products-padding">
                                        <div class="editSets">
                                            <div class="title" fxLayout="row" fxLayoutAlign="start center">
                                                <span> {{title}}
                                                </span>
                                            </div>
                                            <div class="padding-10" autocomplete="off">
                                            
                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Event Name</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-8' + '__' + sanitizedUrl" [readonly]="id > 0" [autocomplete]="'off'" trim="blur"
                                                            required matInput formControlName="summary">
                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.summary.errors?.required">
                                                            Please fill out this field.

                                                        </mat-error>
                                                    </mat-form-field>


                                                </div>
                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Description</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-description' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" required matInput
                                                            formControlName="description"/>
                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.description.errors?.required">
                                                            Please fill out this field.

                                                        </mat-error>
                                                    </mat-form-field>


                                                </div>


                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                                    <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                                        <mat-label>Start Date</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-startdatetime' + '__' + sanitizedUrl" [min]="id==0?today:''" [matDatepicker]="startDateTime"
                                                            formControlName="startDateTime" required matInput/>
                                                        <mat-datepicker-toggle [for]="startDateTime"
                                                            matSuffix></mat-datepicker-toggle>
                                                        <mat-datepicker #startDateTime></mat-datepicker>

                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.startDateTime.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>
                                                    </mat-form-field>


                                                    <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                                                        <mat-label>Start Time</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-starttime' + '__' + sanitizedUrl" type="time" formControlName="startTime" required
                                                            matInput/>

                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.startTime.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>

                                                    </mat-form-field>


                                                </div>


                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">


                                                    <div fxFlex="100" fxLayout="column" fxLayout.lt-md="column"
                                                        fxLayoutGap="10px">
                                                        <div fxFlex="100" fxLayout="row">
                                                            <mat-form-field fxFlex="100" appearance="outline"
                                                                fxLayoutGap="10px">
                                                                <mat-label>End Date</mat-label>
                                                                <input [attr.guide]="'add-edit-google-calendar-service-account-inp-enddatetime' + '__' + sanitizedUrl" [min]="id==0?today:''"
                                                                    [matDatepicker]="endDateTime"
                                                                    formControlName="endDateTime" required matInput/>
                                                                <mat-datepicker-toggle [for]="endDateTime"
                                                                    matSuffix></mat-datepicker-toggle>
                                                                <mat-datepicker #endDateTime></mat-datepicker>

                                                                <mat-error
                                                                    *ngIf="firstFormGroup.controls.endDateTime.errors?.required">
                                                                    Please fill out this field.
                                                                </mat-error>

                                                            </mat-form-field>

                                                        </div>

                                                        <div>
                                                            <span
                                                                *ngIf="firstFormGroup.errors?.dateTimeInvalid && (firstFormGroup.dirty || firstFormGroup.touched)"
                                                                style="color: #f44336; font-size: 12px; margin-top: -8px; margin-left: 14px;">
                                                                End date and time cannot be earlier than Start date and
                                                                time.
                                                            </span>
                                                        </div>

                                                    </div>



                                                    <mat-form-field fxFlex="50" appearance="outline" fxLayoutGap="10px">
                                                        <mat-label>End Time</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-endtime' + '__' + sanitizedUrl" type="time" formControlName="endTime" required matInput/>

                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.endTime.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>

                                                    </mat-form-field>


                                                </div>

                                                <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="10px">

                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Zone</mat-label>
                                                        <mat-select formControlName="timeZone">
                                                            <mat-option *ngFor="let status of zone" [value]="status">
                                                                {{status}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Status</mat-label>
                                                        <mat-select formControlName="status">
                                                            <mat-option *ngFor="let status of statusList"
                                                                [value]="status.viewValue">
                                                                {{status.viewValue}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>

                                                </div>


                                                <div *ngIf="firstFormGroup.value.status == 'Completed'" fxLayout="row"
                                                    fxLayout.lt-md="column" fxLayoutGap="10px">

                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Meeting Summary</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-meetingsummary' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" required matInput
                                                            formControlName="meetingSummary"/>
                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.meetingSummary.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>
                                                    </mat-form-field>


                                                </div>

                                                <div fxLayout="row" *ngIf="id != 0" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">

                                                    <mat-form-field
                                                        *ngIf="firstFormGroup.value.meetingDriveLink!=null && firstFormGroup.value.meetingDriveLink !=undefined && firstFormGroup.value.meetingDriveLink != ''"
                                                        appearance="outline" fxFlex="50">
                                                        <mat-label>Drive Link</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-meetingdrivelink' + '__' + sanitizedUrl" readonly [autocomplete]="'off'" trim="blur" matInput
                                                            formControlName="meetingDriveLink"/>

                                                    </mat-form-field>

                                                    <div fxFlex="100" fxLayoutAlign="space-around center"
                                                        *ngIf="firstFormGroup.value.meetingDriveLink!=null && this.firstFormGroup.value.meetingDriveLink !=undefined && this.firstFormGroup.value.meetingDriveLink != ''">

                                                        <button [attr.guide]="'add-edit-google-calendar-service-account-btn-9' + '__' + sanitizedUrl" (click)="copyToClipboard(firstFormGroup.value.meetingDriveLink)">
                                                            <mat-icon>content_copy</mat-icon>
                                                        </button>


                                                        <button [attr.guide]="'add-edit-google-calendar-service-account-btn-10' + '__' + sanitizedUrl" mat-raised-button
                                                            (click)="navigationTo(firstFormGroup.value.meetingDriveLink)">
                                                            Open Link
                                                        </button>

                                                    </div>



                                                </div>


                                                <div fxLayout="row" *ngIf="leadDisplay" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">
                                                    <mat-form-field fxFlex appearance="outline">
                                                        <mat-label>Name</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-name' + '__' + sanitizedUrl" type="text" (input)="onInputPaitent($event)" matInput
                                                            formControlName="name" [matAutocomplete]="auto1"
                                                            [readonly]="isOptionSelected" />

                                                        <mat-icon *ngIf="isOptionSelected" matSuffix
                                                            (click)="clearInputLead()"
                                                            style="cursor: pointer;">clear</mat-icon>
                                                        <mat-autocomplete #auto1="matAutocomplete">
                                                            <mat-option
                                                                (onSelectionChange)="onLeadSelected($event,option)"
                                                                *ngFor="let option of leadList" [value]="option.name">
                                                                {{option.name}}
                                                            </mat-option>
                                                        </mat-autocomplete>
                                                        <mat-error
                                                            *ngIf="firstFormGroup.controls.name.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>
                                                    </mat-form-field>
                                                </div>

                                                <div fxLayout="row" *ngIf="editMeeetingLink==1" fxLayout.lt-md="column"
                                                    fxLayoutGap="10px">
                                                    <mat-form-field appearance="outline" fxFlex>
                                                        <mat-label>Meeting Link</mat-label>
                                                        <input [attr.guide]="'add-edit-google-calendar-service-account-inp-meetlink' + '__' + sanitizedUrl" [autocomplete]="'off'" trim="blur" required matInput
                                                            formControlName="meetLink"/>
                                                        <mat-error *ngIf="firstFormGroup.controls.meetLink.errors?.required">
                                                            Please fill out this field.
                                                        </mat-error>

                                                    </mat-form-field>
                                                </div>

                                                <div>
                                                    <div class="editSets1">
                                                        <div class="title " fxLayout="row" fxLayoutAlign="start center">
                                                            <span>Attendees</span>
                                                        </div>
                                                        <div class="products-padding" fxLayout="column">

                                                            <div fxFlex="60" fxLayout="column" fxLayout.gt-sm="row"
                                                                fxLayoutAlign="space-between center">


                                                                <button [attr.guide]="'add-edit-google-calendar-service-account-btn-11' + '__' + sanitizedUrl" fxFlex="40" mat-raised-button
                                                                    (click)="openDialog(dialogTemplate)">
                                                                    Add Attendees
                                                                </button>


                                                                <div class="upload" *ngIf="!isFileUploaded">
                                                                    <input [attr.guide]="'add-edit-google-calendar-service-account-inp-12' + '__' + sanitizedUrl" type="file" class="form-control"
                                                                        (change)="onFileChange($event)"
                                                                        placeholder="Upload file"/>
                                                                </div>


<div fxLayout="row" class="padding-10"
                                                                    fxLayoutAlign="start center" fxLayoutGap="5px">
                                                                    <button [attr.guide]="'add-edit-google-calendar-service-account-btn-13' + '__' + sanitizedUrl" mat-raised-button
                                                                        *ngIf="!isFileUploaded && selectedFile"
                                                                        (click)="uploadFile()">Upload</button>
                                                                    <button [attr.guide]="'add-edit-google-calendar-service-account-btn-14' + '__' + sanitizedUrl" mat-raised-button color="warn"
                                                                        *ngIf="isFileUploaded"
                                                                        (click)="cancelUpload()">Cancel</button>
                                                                </div>



                                                            </div>

                                                            <div fxLayout="column" fxFlex="100"
                                                                fxLayoutAlign="start stretch"
                                                                *ngIf="attendeesList.length>0">

                                                                <div id="attribute" fxFlex="100">
                                                                    <div class="padding-11" style="overflow-x: auto;">
                                                                        <div class="editSets" fxLayout="column">
                                                                            <div id="responsieTable" class="container">
                                                                                <div
                                                                                    [ngClass]="attendeesList.length>=5 ? 'minimum' : 'none'">
                                                                                    <table class="rwd-table">
                                                                                        <tbody>
                                                                                            <tr class="table-header">
                                                                                                <th>Attendee</th>
                                                                                                <th>Action</th>

                                                                                            </tr>

                                                                                            <tr *ngFor="let attendee of attendeesList; let k = index"
                                                                                                class="responsive-row">

                                                                                                <td data-th="Name">
                                                                                                    {{ attendee }}
                                                                                                </td>



                                                                                                <td data-th="Action">
                                                                                                    <button [attr.guide]="'add-edit-google-calendar-service-account-btn-15' + '__' + sanitizedUrl" mat-icon-button
                                                                                                        color="warn"
                                                                                                        (click)="removeLinkedCustomer(k)">
                                                                                                        <mat-icon>delete</mat-icon>
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>

                                                                                    <div fxLayout="column"
                                                                                        class="no-records"
                                                                                        *ngIf="attendeesList.length==0"
                                                                                        fxLayoutAlign="center center">
                                                                                        <span>No Records Found</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- <button [attr.guide]="'add-edit-google-calendar-service-account-btn-16' + '__' + sanitizedUrl" type="submit" class="btn btn-primary me-2"
                                                                (click)="onSubmit()">Create</button> -->

                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ng-template #dialogTemplate>
    <div class=" title"
        style=" padding: 16px; font-weight: bold; font-size: 18px; border-top-left-radius: 4px; border-top-right-radius: 4px;">
        Email
        <button [attr.guide]="'add-edit-google-calendar-service-account-btn-17' + '__' + sanitizedUrl" mat-icon-button (click)="closeDialog()" style="float: right; color: white;">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Dialog Body -->
    <div style="padding: 16px;">
        <form [formGroup]="attendeeForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">

                <mat-form-field fxFlex appearance="outline" fxLayoutGap="10px">
                    <mat-label>Email</mat-label>
                    <input [attr.guide]="'add-edit-google-calendar-service-account-inp-email' + '__' + sanitizedUrl" formControlName="email" required matInput/>

                    <mat-error
                        *ngIf="attendeeForm.controls.email.hasError('required') && attendeeForm.controls.email.touched">
                        Please fill out this field.
                    </mat-error>
                    <mat-error
                        *ngIf="attendeeForm.controls.email.hasError('pattern') && attendeeForm.controls.email.touched">
                        Email format is Invalid.
                    </mat-error>



                </mat-form-field>
            </div>
        </form>

        <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 24px;">
            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-18' + '__' + sanitizedUrl" mat-stroked-button (click)="closeDialog()">Close</button>
            <button [attr.guide]="'add-edit-google-calendar-service-account-btn-19' + '__' + sanitizedUrl" [disabled]="attendeeForm.invalid" mat-flat-button color="primary" style="margin-left: 8px;"
                (click)="addAttendee()">Add</button>
        </div>
    </div>
</ng-template>